import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { motion } from 'framer-motion';

const StatsBanner: React.FC = () => {
  return (
    <Box id='bti'
      sx={{
        width: '100%',
        py: 8,
        mx: 'auto',
        background: 'linear-gradient(to top right,rgb(6, 81, 135), #ffffff)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '300px',
      }}
    >
      <Box
        sx={{
          maxWidth: 1000,
          width: '100%',
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-around',
          alignItems: 'center',
          textAlign: 'center',
          gap: { xs: 4, md: 0 },
        }}
      >
        <motion.div
          initial={{ y: -50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{ duration: 1 }}
        >
          <Typography
            variant="h1"
            sx={{ color: '#0A6FB3', fontWeight: 500, fontSize: { xs: '2.5rem', md: '4rem' } }}
          >
            115+
          </Typography>
          <Typography variant="h6" sx={{ color: 'text.secondary', fontSize: { xs: '1rem', md: '1.25rem' } }}>
            clients<br />served in the past ten years.
          </Typography>
        </motion.div>

        <Divider
          orientation="vertical"
          flexItem
          sx={{
            display: { xs: 'none', md: 'block' },
            mx: { md: 4 },
            height: { md: 300 },
            borderRightWidth: '2px',
            borderColor: 'grey.500',
          }}
        />

        <motion.div
          initial={{ y: -50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          <Typography
            variant="h1"
            sx={{ color: '#0A6FB3', fontWeight: 500, fontSize: { xs: '2.5rem', md: '4rem' } }}
          >
            20+
          </Typography>
          <Typography variant="h6" sx={{ color: 'text.secondary', fontSize: { xs: '1rem', md: '1.25rem' } }}>
            countries<br />in our global network
          </Typography>
        </motion.div>
      </Box>
    </Box>
  );
};

export default StatsBanner;
